import LanguageContext from './language.context';

export default LanguageContext;
